var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#twitter_svg__paint0_linear_427_109504)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter_svg__clip0_427_109504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.868 12.174a9.987 9.987 0 01-2.468.704c.397-.069.982-.784 1.214-1.074.354-.436.623-.935.794-1.47 0-.04.04-.097 0-.125a.137.137 0 00-.13 0c-.922.5-1.904.881-2.922 1.136a.205.205 0 01-.204-.052 2.835 2.835 0 00-.255-.266 5.32 5.32 0 00-1.396-.903 4.903 4.903 0 00-2.173-.358 5.255 5.255 0 00-2.065.568 5.351 5.351 0 00-1.634 1.385 5.248 5.248 0 00-.992 1.988 5.462 5.462 0 00-.052 2.1c0 .12 0 .137-.102.12-4.045-.596-7.364-2.033-10.075-5.116-.12-.136-.182-.136-.278 0-1.18 1.794-.607 4.633.868 6.036.198.187.402.369.618.54a5.063 5.063 0 01-1.94-.54c-.114-.074-.176-.034-.182.102a3.349 3.349 0 000 .568 5.158 5.158 0 003.177 4.11c.207.09.421.156.641.2a5.8 5.8 0 01-1.9.056c-.136-.028-.187.046-.136.176.834 2.272 2.643 2.964 3.971 3.35.181.029.363.029.567.074l-.034.034c-.391.716-1.974 1.198-2.7 1.448a9.7 9.7 0 01-4.142.534c-.22-.034-.272-.028-.329 0-.056.029 0 .091.063.148.283.187.567.352.862.51.878.48 1.807.861 2.769 1.137 4.98 1.374 10.586.363 14.324-3.356 2.94-2.919 3.972-6.945 3.972-10.976 0-.154.187-.245.295-.324a9.745 9.745 0 001.946-2.033.597.597 0 00.136-.409c0-.085 0-.068-.108-.022z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "twitter_svg__paint0_linear_427_109504",
    x1: 0.813,
    y1: 0,
    x2: 35.231,
    y2: 43.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CA8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0096E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter_svg__clip0_427_109504"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7.586 7.588)",
    d: "M0 0h24.39v24.39H0z"
  })))));
}

export default SvgTwitter;